import React, { useState, useEffect } from 'react';
import ReactPaginate from 'react-paginate';
import styled from 'styled-components';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';

const ServerPagination = (
  {
    onChange,
    pagesCount,
    itemsCount,
    loading,
    selectedPage = 1,
    pageSizes = [10, 25, 50, 100]
  }
) => {
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [page, setPage] = useState(selectedPage);
  
  useEffect(() => {
    setPage(selectedPage);
  }, [selectedPage])

  const handlePageChange = ({ selected }) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const currentPage = selected + 1;
    setPage(currentPage);
    onChange({ page: currentPage });
  };

  const handleChange = (e) => {
    setPageSize(e.target.value);
    onChange({ pageSize: e.target.value });
  };

  return (
    <PageContainer loading={loading ? 1 : 0}>
      {itemsCount !== 0 && (
        <>
          <div>Rows per Page: </div>
          <Select onChange={handleChange} value={pageSize}>
            {pageSizes.map(size => <option key={size} value={size}>{size}</option>)}
          </Select>
          <div>
            {`${page * pageSize - pageSize || 1}-${
              page * pageSize > itemsCount ? itemsCount : page * pageSize
            } of ${itemsCount || 0}`}
          </div>

          <ReactPaginate
            previousLabel={<BackButton />}
            nextLabel={<NextButton />}
            breakLabel={'...'}
            breakClassName={'break-me'}
            pageCount={pagesCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageChange}
            forcePage={page - 1}
          />
        </>
      )}
    </PageContainer>
  );
};

const BackButton = () => (
  <>
    <FaChevronLeft /> Back
  </>
);

const NextButton = () => (
  <>
    Next <FaChevronRight />
  </>
);

const PageContainer = styled.div`
  color: ${({ theme }) => theme.palette.grayscale[2]};
  display: flex;
  align-items: center;
  font-size: 0.9rem;

  > ul {
    margin: 0;

    li {
      display: inline;
      color: ${({ theme }) => theme.link.color};
      margin: 0 0.4rem;
      cursor: pointer;

      &.selected {
        font-weight: 600;
        border-bottom: 2px solid ${({ theme }) => theme.link.color};
        padding: 0 0.2rem;
      }

      &.disabled {
        color: ${({ theme }) => theme.palette.grayscale[2]};
      }
    }
  }

  ${({ loading }) =>
    loading &&
    `
    visibility: hidden;
  `}
`;

//28	113	203	

const Select = styled.select`
  border: 0;
  background-color: white;
  color: ${({ theme }) => theme.palette.grayscale[2]};
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='292.4' height='292.4'%3E%3Cpath fill='%231c71cb' d='M287 69.4a17.6 17.6 0 0 0-13-5.4H18.4c-5 0-9.3 1.8-12.9 5.4A17.6 17.6 0 0 0 0 82.2c0 5 1.8 9.3 5.4 12.9l128 127.9c3.6 3.6 7.8 5.4 12.8 5.4s9.2-1.8 12.8-5.4L287 95c3.5-3.5 5.4-7.8 5.4-12.8 0-5-1.9-9.2-5.5-12.8z'/%3E%3C/svg%3E");
  background-repeat: no-repeat, repeat;
  /* arrow icon position (1em from the right, 50% vertical) , then gradient position*/
  background-position: right 0.7em top 50%, 0 0;
  /* icon size, then gradient */
  background-size: 1rem auto, 100%;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  margin: 0 0.5rem;
  width: 4rem;
  &::-ms-expand {
    display: none;
  }
`;

export default ServerPagination;
